<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <zestawieniaMenu></zestawieniaMenu>

        <div class="widget-heading d-flex justify-content-between align-items-center">
          <h4 class="my-0">Lojalki</h4>
		  <div class="d-flex gap-2">
            <button class="btn btn-success" @click="openAddModal">
              <i class="bi bi-plus-lg"></i> Dodaj
            </button>
            <a :href="route('kadry.pracownicy.lojalki.pdf')" class="btn btn-info" target="_blank">
              <i class="bi bi-file-earmark-pdf"></i>&nbsp;Lista w PDF
            </a>
		  </div>
		</div>

        <div class="widget-content">
          <div class="table-responsive w-100">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th @click="sortBy('userName')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Nazwisko i imię
                    <span v-if="sortKey === 'userName'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('za_co')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Opis
                    <span v-if="sortKey === 'za_co'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('od_kiedy')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Od kiedy
                    <span v-if="sortKey === 'od_kiedy'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('do_kiedy')" class="bg-gray-100 text-start" style="cursor:pointer">
                   Do kiedy
                    <span v-if="sortKey === 'do_kiedy'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('okres')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Jaki okres
                    <span v-if="sortKey === 'okres'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>				  
                  <th @click="sortBy('kwota')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Kwota
                    <span v-if="sortKey === 'kwota'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                   <th @click="sortBy('amount')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Pozostało
                    <span v-if="sortKey === 'amount'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
				  <th class="bg-gray-100">Opcje</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="lojalka in sortedLojalki" :key="lojalka.id">
                  <td class="text-start">{{ lojalka.userName }}</td>
                  <td class="text-start">{{ lojalka.za_co }}</td>
                  <td class="text-start">{{ lojalka.od_kiedy }}</td>
                  <td class="text-start">
  {{ calculateEndDate(lojalka) }}
</td>
                  <td class="text-start">
  {{ formatOkres(lojalka.okres) }}
</td>
                  <td class="text-start">{{ lojalka.kwota }}</td>
                   <td class="text-start">
  {{ calculateAmount(lojalka) }}
</td>
                   <td>
                    <button class="btn btn-sm btn-primary me-1" @click="openEditModal(lojalka)">Edytuj</button>
                    <button class="btn btn-sm btn-danger" @click="deleteLojalka(lojalka.id)">Usuń</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Modal -->
        <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block; background-color: rgba(0,0,0,0.5)">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ isEditing ? 'Edytuj lojalke' : 'Dodaj lojalkę' }}</h5>
                <button type="button" class="btn-close" @click="closeModal"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Pracownik</label>
					<select v-model="form.user_id" class="select2 form-select w-100" id="sel_user_id">
					  <option v-for="user in users" :key="user.id" :value="user.id">
						{{ user.last_name }} {{ user.first_name }}
					  </option>
					</select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Opis</label>
                    <input v-model="form.za_co" type="text"  class="form-control" />
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="form-label">Od kiedy</label>
                    <input v-model="form.od_kiedy" type="date" class="form-control" />
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="form-label">Okres</label>
                    <select v-model="form.okres" class="form-control">
					  <option value="1">1 rok</option>
					  <option value="2">2 lata</option>
					  <option value="3">3 lata</option>
					</select>					
					
                  </div>				  
                  <div class="col-md-6 mt-3">
                    <label class="form-label">Kwota</label>
                    <input v-model="form.kwota"  type="number" step="0.01" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeModal">Anuluj</button>
                <button class="btn btn-success" @click="saveLojalka">{{ isEditing ? 'Zapisz zmiany' : 'Dodaj' }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Koniec modal -->
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";
import axios from "axios";

export default {
  components: { AppLayout, zestawieniaMenu },
  props: {
    lojalki: { type: Array, required: true },
    users: { type: Array, required: true },
  },
  data() {
    return {
      sortKey: "userName",
      sortOrder: "asc",
      isModalOpen: false,
      isEditing: false,
      form: {
        id: null,
        user_id: null,
        za_co: "",
        okres: "",
        od_kiedy: "",
        kwota: "",
        amount: "",
        do_kiedy: "",
     },
      localLojalki: [],
    };
  },
  computed: {
    sortedLojalki() {
      return this.localLojalki.slice().sort((a, b) => {
        let aVal = a[this.sortKey];
        let bVal = b[this.sortKey];
        if (typeof aVal === "string") {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }
        if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
        if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    },
  },
  mounted() {
  this.localLojalki = this.lojalki.map(t => ({ ...t }));

  this.$nextTick(() => {
    this.autoDeleteExpired();
  });
  },
  methods: {
async autoDeleteExpired() {
  // robimy kopię tablicy, żeby bezpiecznie iterować
  for (const lojalka of [...this.localLojalki]) {
    const amount = parseFloat(this.calculateAmount(lojalka));

    // Usuń tylko jeśli rekord jest aktywny i amount = 0
    if (amount === 0) {
      try {
        await axios.delete(`/kadry/pracownicy/lojalki/del/${lojalka.id}`);
        
        // usuwamy z tabeli lokalnie
        this.localLojalki = this.localLojalki.filter(t => t.id !== lojalka.id);

        this.showToast('info', 'Auto-usunięcie', `Usunięto wygasłą lojalkę: ${lojalka.userName}`);
      } catch (error) {
        console.error('Błąd auto-usuwania:', error);
      }
    }
  }
},
    formatDate(date) {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
  },

calculateEndDate(lojalka) {
  if (!lojalka.od_kiedy || !lojalka.okres) return '';

  // jeśli użytkownik nieaktywny, używamy umowa_do
  if (!lojalka.is_active && lojalka.umowa_do) {
    return this.formatDate(lojalka.umowa_do);
  }

  const date = new Date(lojalka.od_kiedy);
  date.setFullYear(date.getFullYear() + Number(lojalka.okres));

  return this.formatDate(date);
},


    formatOkres(okres) {
    if (okres == 1) return '1 rok';
    if (okres >= 2 && okres <= 4) return `${okres} lata`;
    return `${okres} lat`;
  },
calculateAmount(lojalka) {
  if (!lojalka.od_kiedy || !lojalka.kwota || !lojalka.okres) return 0;

  const start = new Date(lojalka.od_kiedy);
  let end;

  // jeśli user nieaktywny, kończymy na umowa_do
  if (!lojalka.is_active && lojalka.umowa_do) {
    end = new Date(lojalka.umowa_do);
  } else {
    end = new Date(lojalka.od_kiedy);
    end.setFullYear(end.getFullYear() + Number(lojalka.okres));
  }

  const today = new Date();
  const effectiveDate = today < end ? today : end;

  let months =
    (effectiveDate.getFullYear() - start.getFullYear()) * 12 +
    (effectiveDate.getMonth() - start.getMonth());

  if (months < 0) months = 0;

  const totalMonths = lojalka.okres * 12;
  const monthly = lojalka.kwota / totalMonths;

  let remaining = lojalka.kwota - (monthly * months);
  if (remaining < 0) remaining = 0;

  return remaining.toFixed(2);
},
	initUserSelect() {
	  this.$nextTick(() => {
		if ($('#sel_user_id').hasClass("select2-hidden-accessible")) {
		  $('#sel_user_id').select2('destroy');
		}

		$('#sel_user_id')
		  .select2({
			dropdownParent: $('.modal')
		  })
		  .val(this.form.user_id || '')  // ustawienie domyślnej wartości
		  .trigger('change')
		  .on('select2:select', (e) => {
			const selectedUserId = parseInt(e.params.data.id);
			this.form.user_id = selectedUserId;
		  });
	  });
	},
    sortBy(key) {
      if (this.sortKey === key) this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      else this.sortKey = key;
    },
    openAddModal() {
      this.isEditing = false;
      this.form = { id: null, user_id: null, za_co: "", od_kiedy: "", kwota: "", okres: "" };
      this.isModalOpen = true;
	  this.initUserSelect();
    },
openEditModal(lojalka) {
  this.isEditing = true;
  this.form = {
    id: lojalka.id,                
    user_id: Number(lojalka.user_id),
    za_co: lojalka.za_co,
    okres: lojalka.okres,
    od_kiedy: lojalka.od_kiedy,
    kwota: lojalka.kwota,
  };

  this.isModalOpen = true;

  this.$nextTick(() => {
    if ($('#sel_user_id').hasClass("select2-hidden-accessible")) {
      $('#sel_user_id').select2('destroy');
    }
    $('#sel_user_id')
      .select2({
        dropdownParent: $('.modal'),
      })
      .val(this.form.user_id) 
      .trigger('change')  
      .on('select2:select', (e) => {
        const selectedUserId = parseInt(e.params.data.id);
        this.form.user_id = selectedUserId;

      });
  });
},
    closeModal() {
      this.isModalOpen = false;
    },
async saveLojalka() {
  try {
    if (this.isEditing) {

      if (!this.form.id) {
        console.error('Brak ID przy edycji!', this.form);
        return;
      }

      await axios.put(`/kadry/pracownicy/lojalki/update/${this.form.id}`, this.form);

      const index = this.localLojalki.findIndex(t => t.id === this.form.id);
      const user = this.users.find(u => u.id === this.form.user_id);

      this.localLojalki[index] = {
        ...this.form,
        userName: `${user.first_name} ${user.last_name}`
      };

    } else {

      const res = await axios.post('/kadry/pracownicy/lojalki/add', this.form);

      const user = this.users.find(u => u.id === this.form.user_id);

      this.localLojalki.push({
        id: res.data.id, // KLUCZOWE
        user_id: this.form.user_id,
        userName: `${user.first_name} ${user.last_name}`,
        za_co: this.form.za_co,
        okres: this.form.okres,
        od_kiedy: this.form.od_kiedy,
        kwota: this.form.kwota,
      });

    }

    this.closeModal();
    this.showToast('success', 'Zapisano', 'Dane zostały zaktualizowane.');

  } catch (error) {
    console.error(error);
    this.showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
  }
},
    async deleteLojalka(id) {
      if (!confirm("Na pewno chcesz usunąć tę lojalkę?")) return;
      try {
        await axios.delete(`/kadry/pracownicy/lojalki/del/${id}`);
        this.localLojalki = this.localLojalki.filter(t => t.id !== id);
		this.showToast('success', 'Usunięto', 'Dane zostały usunięte.');
      } catch (error) {
        console.error(error);
        this.showToast('error', 'Błąd', 'Nie udało się usunąć danych.');
      }
    },
	    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

  },
};
</script>

<style scoped>
table th,
table td {
  min-width: 50px;
  height: 32px;
  text-align: center;
}
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}
</style>